import React from 'react'
import ExpenseReport, {
  ExpenseReportContext,
} from 'src/app/ExpenseReport/ExpenseReport'

/**
 * Flat-route adapter for the /expensereport/:id accounting detail entry point.
 *
 * The flat route registry binds a prop-less `ComponentType`, but the legacy
 * `expenseReport.appRoute` rendered
 * `<ExpenseReport context={ExpenseReportContext.accounting} />`. This thin
 * wrapper preserves that exact binding so the accounting variant of the report
 * is reached on direct load of /expensereport/:id. The report id is still
 * resolved inside ExpenseReport via `selectExpenseReportIdFromRoute` (matchPath
 * over the unchanged route path), so this adapter takes no props.
 */
const ExpenseReportAccounting: React.FC = () => (
  <ExpenseReport context={ExpenseReportContext.accounting} />
)

export default ExpenseReportAccounting
